import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpResponse,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { tap } from 'rxjs';
import { AuthService } from './auth.service';
import { StorageService } from '../../shared/storage/storage.service';
import { AUTH_CONSTS } from './auth.const';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private storage = inject(StorageService);
  private authService = inject(AuthService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    // Check if Authorization header already exists (e.g., from ImpersonationInterceptor)
    const existingAuthHeader = req.headers.get('Authorization');
    const refreshToken = this.storage.get<string>(AUTH_CONSTS.refreshToken);

    if (existingAuthHeader) {
      return this.trackSessionHeaders(req, next);
    }

    const token = this.storage.get<string>(AUTH_CONSTS.token);
    // console.log('AuthInterceptor: Adding token to request:', !!token);
    if (!token) {
      return next.handle(req);
    }

    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        ...(refreshToken ? { 'X-Refresh-Token': refreshToken } : {}),
      },
    });

    return this.trackSessionHeaders(cloned, next);
  }

  private trackSessionHeaders(req: HttpRequest<unknown>, next: HttpHandler) {
    const shouldTrackSessionHeaders = req.headers.has('X-Refresh-Token');

    return next.handle(req).pipe(
      tap((event: HttpEvent<unknown>) => {
        if (!shouldTrackSessionHeaders || !(event instanceof HttpResponse)) {
          return;
        }

        this.authService.updateSessionTimeoutFromHeaders(
          event.headers.get('X-Session-Idle-Seconds'),
          event.headers.get('X-Session-Timeout-Seconds')
        );
      })
    );
  }
}
